export default {
    'enumerate.xpdyj': '小票打印机',
    'enumerate.pmdyj': '喷墨打印机',
    'enumerate.dbd': '打包袋',
    'enumerate.hc': '盒菜',
    'enumerate.wb': '微波',
    'enumerate.tl': '调料',
    'enumerate.cj': '餐具',
    'enumerate.yl': '饮料'
}